import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-email-modal',
  templateUrl: './confirm-delete-email-modal.component.html'
})
export class ConfirmDeleteEmailModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
